import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import {
  LayoutDashboard,
  Boxes,
  Users,
  Contact,
  BarChart3,
  Heart,
  Settings,
  LogOut,
  Shield,
  Database,
  Target,
  ArrowLeftRight,
} from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { getTheme } from "../lib/unitTheme";
import AssistantWidget from "../components/AssistantWidget";

const NAV = [
  { to: "", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "nav-master-dashboard" },
  { to: "estoque", label: "Produtos & Estoque", icon: Boxes, testid: "nav-master-estoque" },
  { to: "movimentacoes", label: "Movimentações", icon: ArrowLeftRight, testid: "nav-master-movimentacoes" },
  { to: "vendedores", label: "Vendedores", icon: Users, testid: "nav-master-vendedores" },
  { to: "clientes", label: "Clientes", icon: Contact, testid: "nav-master-clientes" },
  { to: "performance", label: "Performance", icon: BarChart3, testid: "nav-master-performance" },
  { to: "retencao", label: "Retenção", icon: Heart, testid: "nav-master-retencao" },
  { to: "metas", label: "Metas", icon: Target, testid: "nav-master-metas" },
  { to: "backup", label: "Backup", icon: Database, testid: "nav-master-backup" },
  { to: "configuracoes", label: "Configurações", icon: Settings, testid: "nav-master-config" },
];

export default function MasterLayout() {
  const navigate = useNavigate();
  const { session, logout } = useAuth();
  const theme = getTheme("master");

  useEffect(() => {
    if (!session || session.tipo !== "master") navigate("/");
  }, [session, navigate]);

  if (!session || session.tipo !== "master") return null;

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col">
      <header className={`${theme.header} px-4 sm:px-6 h-16 flex items-center justify-between`}>
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-yellow-400 flex items-center justify-center">
            <Shield className="w-4 h-4 text-neutral-950" strokeWidth={2.5} />
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-yellow-400">
              Administração
            </p>
            <h1 className="font-display font-black text-lg tracking-tight">Painel Master</h1>
          </div>
        </div>
        <button
          data-testid="master-logout-btn"
          onClick={handleLogout}
          className="flex items-center gap-2 bg-white/10 hover:bg-white/20 px-3 h-10 font-mono text-xs uppercase tracking-widest transition-colors"
        >
          <LogOut className="w-4 h-4" /> Sair
        </button>
      </header>

      <div className="flex-1 flex flex-col md:flex-row">
        <aside className="w-full md:w-60 md:border-r-2 border-neutral-900 bg-white">
          <nav className="flex md:flex-col overflow-x-auto md:overflow-visible">
            {NAV.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.to}
                  end={item.end}
                  to={item.to}
                  data-testid={item.testid}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 md:py-4 font-display font-bold text-sm uppercase tracking-wide transition-colors border-b md:border-b-2 md:border-l-4 border-neutral-200 md:border-l-transparent whitespace-nowrap ${
                      isActive ? theme.activeNav : "text-neutral-700 hover:bg-neutral-100"
                    }`
                  }
                >
                  <Icon className="w-4 h-4" strokeWidth={2.5} />
                  {item.label}
                </NavLink>
              );
            })}
          </nav>
        </aside>

        <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-auto">
          <Outlet />
        </main>
      </div>

      <AssistantWidget escopo="master" />
    </div>
  );
}
